<template>
  <div>
    <SellVisual :city="city" />
    <SellMain :city-name="city.name">
      <SideFormContainer slot="side">
        <SellForm :city-name="city.name" />
      </SideFormContainer>
      <SellBody
        slot="body"
        :city-name="city.name"
        :show-message="doubleOptin"
      />
    </SellMain>
    <SellFooter />
  </div>
</template>

<script>
// Libs
import { mapState } from 'vuex'

// Mixins
import SellMixin from '~/mixins/sell'

// Components
import SellForm from '~/components/SellForm.vue'
import SideFormContainer from '~/components/SideFormContainer.vue'
import SellBody from '~/components/SellBody.vue'
import SellFooter from '~/components/SellFooter.vue'
import SellMain from '~/components/SellMain.vue'
import SellVisual from '~/components/SellVisual.vue'

export default {
  components: {
    SellForm,
    SideFormContainer,
    SellBody,
    SellFooter,
    SellMain,
    SellVisual,
  },

  mixins: [SellMixin],

  async asyncData({ store, params }) {
    await store.dispatch('sell/fetchCity', `/vendere-casa-${params.slug}`)

    return {
      meta: {
        title: store.state.sell.city.title,
        description: store.state.sell.city.description,
      },
    }
  },

  computed: {
    ...mapState('sell', ['city']),
  },
}
</script>
